import { usePlansContext } from '@mc/plans-ui'
import { CERTS_VALUES, isCampaignCertsValue } from '../constants'
import { useCertsQuizIntent } from './useCertsQuizIntent'
import { useExperiment } from './useExperiment'

/**
 * Entry criteria for the plans-page half of prcng-1138_v1, and the single gate
 * every surface here reads — the card, the plans primer line and the FAQ entry.
 *
 * Deliberately independent of this experiment's bucket, so control and
 * variant_1 enrol identically: GrowthBook assigning a variant is harmless, the
 * `Experiment Viewed` event is what enrols a user into the analysis.
 *
 * `preselected` admits an off-site campaign visitor whatever their bucket
 * (PRCNG-1193). It must stay a bypass rather than a forced bucket: forcing via
 * `?exp_prcng-1138_v1=variant_1` writes a site-wide `mc_gb_force` cookie for
 * three days, so the visitor would later fire the quiz page's exposure event
 * as variant_1 and skew the live experiment's arms.
 */
export const useExperimentCriteria = () => {
  const { isGift } = usePlansContext()
  const { certsValue } = useCertsQuizIntent()
  const { isVariant } = useExperiment()

  // Two different questions. `isCampaign` is provenance and holds for every
  // spelling, so a campaign visitor stepping back from the payment step on
  // `ap` or `dp` stays eligible. `isPreselected` is the arrival alone, and only it
  // seeds the card as already taken.
  const isCampaign = isCampaignCertsValue(certsValue)
  const isPreselected = certsValue === CERTS_VALUES.preselected

  // Withheld until the page supplies a `certsValue`.
  const isEligible = (isVariant || isCampaign) && !isGift && !!certsValue

  return { isEligible, isPreselected, isCampaign }
}
